import { useState, useEffect } from "react";

export const FnsHeader = () => {
  const [hdrClass, setHdrClass] = useState('nav-init')

  useEffect(() => {
    let gnavScrlPos = 0
    const scrollLister = () => {
      const y = window.scrollY
      if (y <= 0) {
        setHdrClass('nav-init')
      } else if (y - gnavScrlPos > 0) {
        setHdrClass('UpMove')
      } else if (y - gnavScrlPos < -10) {
        setHdrClass('DownMove')
      }
      gnavScrlPos = y
    }
    window.addEventListener('scroll', scrollLister)
    return function cleanUp() {
      window.removeEventListener('scroll', scrollLister)
    }
  }, [])
  return <>
    <header>
      <div id="hdr__nav" className={`hdr__nav ${hdrClass}`}>
        <h1 className="hdr__nav__logo">Family Works</h1>
      </div>
      <div className="hdr__title"></div>
    </header>
  </>
}